import Users from './Users';
import ListUsers from './ListUsers';

export default function Admin() {

    return (
        <>
        {Users()}
        {ListUsers()}
        </>
    )
}